module.exports = __webpack_public_path__ + "media/newstyle/images/icon-speak-orange-d47f1b2ee4d073a2cbf4f7e15b9e1231.svg";